import { createRoot } from "react-dom/client";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { theme, AuthProvider, PasscodeGuard } from "@kxd/ui";
import "./index.css";
import App from "./App";

createRoot(document.getElementById("root")!).render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <AuthProvider>
      <PasscodeGuard>
        <App />
      </PasscodeGuard>
    </AuthProvider>
  </ThemeProvider>
);
